import React, { useState, Fragment, useEffect } from "react";
import { getTitleTable, getDataSource, columnsTable, genaratePaginateFilterSort, checkUndefine, formatValidation } from "../../../../../helpers/functions";
import { FilterDropdown, ListComponent, StatusComponent } from "../../../common/component/Index";
import './RecommendationList.less';
import * as ANT from "antd";
import * as Func from '../../../../../helpers/functions';

const ListCols = [
    'user',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5'
];

const RecommendationList = ({ ...props }) => {
    const {
        data,
        pagination,
        activeTab = 'USER'
    } = props;

    const [arrData, setArrData] = useState([])
    const [titleItemTable] = useState(Func.getTitleTable(ListCols, [], []))
    const [componentTable] = useState({
        'user': {
            key: 'email',
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <FilterDropdown
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                >
                </FilterDropdown>
            ),
            filterIcon: filtered => (
                <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
            ),
            width: 200,
            fixed: 'left'
        },
        '0': {
            key: '0',
            render: (sortItem, record) => sortItem && <span>
                {sortItem.name}: {sortItem.point}{activeTab === 'USER' ? `|${sortItem.weight}` : ''}
            </span>,
        },
        '1': {
            key: '1',
            render: (sortItem, record) => sortItem && <span>
                {sortItem.name}: {sortItem.point}{activeTab === 'USER' ? `|${sortItem.weight}` : ''}
            </span>,
        },
        '2': {
            key: '2',
            render: (sortItem, record) => sortItem && <span>
                {sortItem.name}: {sortItem.point}{activeTab === 'USER' ? `|${sortItem.weight}` : ''}
            </span>,
        },
        '3': {
            key: '3',
            render: (sortItem, record) => sortItem && <span>
                {sortItem.name}: {sortItem.point}{activeTab === 'USER' ? `|${sortItem.weight}` : ''}
            </span>,
        },
        '4': {
            key: '4',
            render: (sortItem, record) => sortItem && <span>
                {sortItem.name}: {sortItem.point}{activeTab === 'USER' ? `|${sortItem.weight}` : ''}
            </span>,
        },
        '5': {
            key: '5',
            render: (sortItem, record) => sortItem && <span>
                {sortItem.name}: {sortItem.point}{activeTab === 'USER' ? `|${sortItem.weight}` : ''}
            </span>,
        },
    })

    useEffect(()=>{
        if(data){
            const dataTmp = data.map(item => {
                return {
                    ...Object.assign({}, item.top),
                    user: item.user
                }
            })
            setArrData(dataTmp)
        }
    }, [data])

    return (
        <Fragment>
            <ListComponent
                tableKey="bundle-list"
                scroll={{ x: 1600 }}
                bordered
                classChildren="p-0" classParent="m-0"
                rowKey={ (record, k) => record.id ? record.id : k }
                loading={ { spinning: props.isFetching, size: 'large' } }
                dataSource={ arrData }
                columns={ columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'recommendation'
                }) }
                componentTableList={ {} }
                pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, current: pagination.defaultCurrent, pageSize: pagination.pageSize }}
                onChange={props.onChange}
            >
            </ListComponent>
        </Fragment>
    )
}

export default RecommendationList;
